export default __webpack_public_path__ + "static/media/phone-clock.11c67d94.svg";